module.exports = __webpack_public_path__ + "static/contact-083b6aad52cd86c20810cfa0d92a674b.jpg";